export default __webpack_public_path__ + "static/B0117-39ecc52743d6023fadd0fc2d279a3432.png";